import {useState} from "react";
import DateHelper from "../../helpers/dateHelper";
import EpgPageHelpers from "../../helpers/epgPageHelpers";
import {getEpgDetailsAsync} from "./EpgDetailsModal/epgDetailsSlice.ts";
import {modalsStateActions} from "../popups/modalsStateSlice.ts";
import {useAppDispatch, useAppSelector} from "../../stores/store.ts";
import {useModal} from "../../hooks/useModal.tsx";
import {IPlayerChannel} from "../../interfaces/IPlayerUIState.ts";
import EpgDetails from "./EpgDetailsModal/EpgDetails.tsx";
import {useChannelsService} from "../../hooks/useChannelsService.tsx";

interface props {
    epgId: number;
    channelId: number;
    channelName: string;
    startTimestamp: number;
    endTimestamp: number;
    name: string;
    description: string;
    handleEpgItemClick: Function;
    hourInPixels?: number;
    className?: string;
    index?: number
    scrollLeft?: number
}

export const EpgItem = ({
                            channelName,
                            endTimestamp,
                            epgId,
                            startTimestamp,
                            name,
                            hourInPixels = 240,
                            className,
                        }: props) => {
    const {channels} = useChannelsService();
    const {showModal} = useModal();
    const dispatch = useAppDispatch();
    const [startHourAndMinute] = useState(
        DateHelper.GetHourAndMinuteFromUnixTimespanDate(startTimestamp)
    );
    const [endHourAndMinute] = useState(
        DateHelper.GetHourAndMinuteFromUnixTimespanDate(endTimestamp)
    );
    const firstHourTimeline = useAppSelector(state => state.epgPage.timelineHours[0]);

    const currentDate = () => {
        const dateNow = new Date();
        return Math.floor(dateNow.getTime() / 1000);
    };

    const epgItemWidth = EpgPageHelpers.timeStampStartAndStopToWidthConverter(
        startTimestamp,
        endTimestamp,
        firstHourTimeline.timestamp,
        hourInPixels
    );
    const modalHeader = (channelName: string, name: string) =>
        <div>
            <p className={"text-neutral-400 font-medium"}>{channelName}</p>
            {/*<h1 className={"text-2xl"}>{name}</h1>*/}
            <h1 className={"text-2xl line-clamp-2"}>{name}</h1>
        </div>

    const modalContent = () =>
        <EpgDetails channels={channels.map(x => ({
            ch_id: x.ch_id,
            cmd: x.cmd,
            enabled: x.enabled,
            epgList: x.epgList,
            firstEpgId: 0,
            lastEpgId: 0,
            logo: x.logo,
            name: x.name
        } as IPlayerChannel))}/>
    const handleClickEpgInfo1 = (id: number, name: string, channelName: string) => {
        dispatch(getEpgDetailsAsync({id, channelName}));
        showModal(modalHeader(channelName, name), modalContent());
        // dispatch(modalsStateActions.setIsEpgDetailsOpen(true));
    }
    return (
        <button
            onClick={() => handleClickEpgInfo1(epgId, name, channelName)}
            className={`epg-page-item__button shrink-0 ${endTimestamp < currentDate() ? "bg-neutral-900/50" : ""} ${className}`}
            style={{
                width: `${epgItemWidth}px`,
                paddingLeft: `${epgItemWidth > 6 ? 4 : 0}px`,
            }}
            title={`${name} - ${startHourAndMinute}-${endHourAndMinute}`}
        >
            <p
                className={`epg-page-item__button-text ${endTimestamp < currentDate() ? "text-neutral-500" : "text-neutral-200"} hover:text-neutral-100 transition-colors`}
            >
                {name} - {startHourAndMinute} : {endHourAndMinute}
            </p>
        </button>
    );
};